import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import taskService from '../../services/taskService';
import projectService from '../../services/projectService';
import milestoneService from '../../services/milestoneService';
import './TaskForm.css';
import IssueStore from '../Issues/IssueStore';
import { FiUpload, FiX, FiFile } from 'react-icons/fi';
import TaskStore from './TaskStore';
import RichTextEditor from '../Common/RichTextEditor';
import { toast } from 'react-toastify';

const TABS = [
  { id: 'details', label: 'Task Details' },
  { id: 'attachments', label: 'Attachments' },
  { id: 'history', label: 'Comments' },
];

const TaskForm = ({ isEdit = false }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [activeTab, setActiveTab] = useState('details');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [projects, setProjects] = useState([]);
  const [milestones, setMilestones] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [parentTasks, setParentTasks] = useState([]);
  const [users, setUsers] = useState([]);
  const [attachments, setAttachments] = useState([]);
  const [dragOver, setDragOver] = useState(false);
  const [pendingFile, setPendingFile] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState('');
  const [attachment, setAttachment] = useState(null);
  const [taskId, setTaskId] = useState(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    setAttachment({
      id: Date.now(),
      name: file.name,
      size: file.size,
      type: file.type,
      uploadedAt: new Date().toLocaleString(),
      file,
    });
  };

  const removeAttachment = () => {
    setAttachment(null);
  };

  const [formData, setFormData] = useState({
    title: '',
    description: '',
    task_type: 'Task',
    status: 'To Do',
    priority: 'Medium',
    project_id: '',
    milestone_id: '',
    parent_task_id: '',
    assigned_to: '',
    start_date: '',
    due_date: '',
    estimated_hours: 0,
    tags: '',
    remaing_hours: 0,
    actual_hours: 0
  });


  const { selectedIssue, setSelectedIssue, clearSelectedIssue } = IssueStore();
  const { copySelectedTask, setSelectedCopyTask, clearSelectedCopyTask } = TaskStore();

  useEffect(() => {
    fetchProjects();
    // fetchMilestones();
    fetchTasks();
    loadUsers();
    fetchComments();
    fetchCopiedTask()
    console.log("selected issue", selectedIssue, copySelectedTask)

    if (isEdit && id) {
      fetchTask();
    }

    if (selectedIssue) {
      fetchIssue();
    }

  }, [isEdit, id, selectedIssue]);

  const fetchProjects = async () => {
    try {
      const data = await projectService.getAllProjects();
      setProjects(data.projects || []);
    } catch (err) {
      console.error('Failed to fetch projects:', err);
    }
  };

  const fetchComments = async () => {
    try {
      const data = await taskService.getComments(id);
      setComments(data.comments);
    } catch (err) {
      console.error('Failed to fetch comments:', err);
    }
  };

  const fetchMilestones = async () => {
    try {
      const data = await milestoneService.getAllMilestones();
      setMilestones(data.data || []);
    } catch (err) {
      console.error('Failed to fetch milestones:', err);
    }
  };

  const fetchTasks = async () => {
    try {
      const data = await taskService.getAllTasks();
      // Filter out current task if editing to prevent circular reference
      const filteredTasks = isEdit && id
        ? (data.tasks || []).filter(task => task.id !== id)
        : (data.tasks || []);
      setTasks(filteredTasks);
    } catch (err) {
      console.error('Failed to fetch tasks:', err);
    }
  };


  const handleLogoUpload = async () => {
    if (!attachment) {
      toast.error('error', 'Please select a logo file');
      return;
    }
    try {
      const response = await taskService.uploadTaskAttatchment(attachment.file, taskId);
      setAttachment(null);

      toast.success('success', 'Logo uploaded successfully');
    } catch (error) {
      toast.error('error', error.response?.data?.message || 'Failed to upload logo');
    }
  };


  const loadUsers = async () => {
    try {
      // This would need a user service - for now using mock data
      const data = await taskService.getAll();
      console.log("users", data)
      setUsers(data.users || []);
    } catch (error) {
      console.error('Error loading users:', error);
    }
  };

  const fetchParentTasksForProject = async (projectId) => {
    if (!projectId) {
      setParentTasks([]);
      return;
    }
    try {
      const data = await taskService.getParentTasksByProject(projectId);
      setParentTasks(data.tasks || data.data || []);
    } catch (error) {
      console.error('Failed to fetch parent tasks:', error);
      toast.error(error.response?.data?.error || 'Failed to fetch parent tasks');
    }
  };

  const fetchTask = async () => {
    try {
      setLoading(true);
      const data = await taskService.getTaskById(id);
      const task = data.task;
      console.log("task", task)
      setTaskId(task.id)
      setFormData({
        title: task.title || '',
        description: task.description || '',
        task_type: task.task_type || 'Task',
        status: task.status || 'To Do',
        priority: task.priority || 'Medium',
        project_id: task.project_id || '',
        milestone_id: task.milestone_id || '',
        parent_task_id: task.parent_task_id || '',
        assigned_to: task.assigned_to || '',
        start_date: task.start_date ? task.start_date.split('T')[0] : '',
        due_date: task.due_date ? task.due_date.split('T')[0] : '',
        estimated_hours: task.estimated_hours || '',
        tags: task.tags || '',
        actual_hours: task.actual_hours || ''
      });

      if (task.project_id) {
        await fetchMilestonesForProject(task.project_id);
        await fetchParentTasksForProject(task.project_id);
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to fetch task');
    } finally {
      setLoading(false);
    }
  };
  const handleAddComment = async (e) => {
    e.preventDefault();
    if (!newComment.trim()) return;

    try {
      await taskService.addComment(id, newComment);
      setNewComment('');
      fetchComments();
    } catch (err) {
      alert(err.response?.data?.error || 'Failed to add comment');
    }
  };

  const fetchCopiedTask = async () => {

    setFormData({
      title: copySelectedTask?.title || '',
      description: copySelectedTask?.description || '',
      task_type: copySelectedTask?.task_type || 'Task',
      status: copySelectedTask?.status || 'To Do',
      priority: copySelectedTask?.priority || 'Medium',
      project_id: copySelectedTask?.project_id || '',
      milestone_id: copySelectedTask?.milestone_id || '',
      parent_task_id: copySelectedTask?.parent_task_id || '',
      assigned_to: copySelectedTask?.assignee?.id || '',
      start_date: copySelectedTask?.start_date ? copySelectedTask?.start_date.split('T')[0] : '',
      due_date: copySelectedTask?.due_date ? copySelectedTask?.due_date.split('T')[0] : '',
      estimated_hours: copySelectedTask?.estimated_hours || '',
      tags: copySelectedTask?.tags || '',
      actual_hours: copySelectedTask?.actual_hours || ''
    });

  };

  const fetchIssue = async () => {
    console.log("seteee data")
    setFormData({
      title: selectedIssue.title || '',
      description: selectedIssue.description || '',
      task_type: selectedIssue.task_type || 'Task',
      status: selectedIssue.status || 'To Do',
      priority: selectedIssue.priority || 'Medium',
      project_id: selectedIssue.project_id || '',
      milestone_id: selectedIssue.milestone_id || '',
      parent_task_id: selectedIssue.parent_task_id || '',
      assigned_to: selectedIssue.assignee_id || '',
      start_date: selectedIssue.start_date ? selectedIssue.start_date.split('T')[0] : '',
      due_date: selectedIssue.due_date ? selectedIssue.due_date.split('T')[0] : '',
      estimated_hours: selectedIssue.estimated_hours || '',
      tags: selectedIssue.tags || ''
    });

  };

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData(prev => ({ ...prev, [name]: value }));
  // };


  const handleChange = (e) => {
    const { name, value } = e.target;

    console.log("values", name, value)

    setFormData((prev) => {
      const updatedData = {
        ...prev,
        [name]: value,
        issue_id: selectedIssue?.id
      };

      const estimated = parseFloat(updatedData.estimated_hours) || 0;
      const completed = parseFloat(updatedData.actual_hours) || 0;

      if (completed > estimated && estimated > 0) {
        setError("Exceed hours.");
      } else {
        setError("");
      }

      return {
        ...updatedData,
        remaing_hours: estimated - completed,
      };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      // Convert empty strings to null for optional fields
      const submitData = {
        ...formData,
        project_id: formData.project_id || null,
        milestone_id: formData.milestone_id || null,
        parent_task_id: formData.parent_task_id || null,
        assigned_to: formData.assigned_to || null,
        start_date: formData.start_date || null,
        due_date: formData.due_date || null,
        estimated_hours: formData.estimated_hours ? parseFloat(formData.estimated_hours) : null
      };

      if (isEdit) {
        await taskService.updateTask(id, submitData);
        toast.success("Update successfully ")

      } else {
        await taskService.createTask(submitData);
        toast.success("Create successfully ")
      }

      navigate('/app/tasks');
    } catch (err) {
      setError(err.response?.data?.error || `Failed to ${isEdit ? 'update' : 'create'} task`);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => navigate('/app/tasks');

  const handleFileSelect = (e) => {
    const files = Array.from(e.target.files);
    if (files.length > 0) setPendingFile(files[0]);
    simulateUpload(files);
  };

  const simulateUpload = async (files) => {
    for (let i = 0; i <= 100; i += 10) {
      setUploadProgress(i);
      await new Promise(resolve => setTimeout(resolve, 100));
    }
    addFiles(files);
    setPendingFile(null);
    setUploadProgress(0);
  };

  const addFiles = (files) => {
    const newAttachments = files.map(file => ({
      id: Date.now() + Math.random(),
      name: file.name,
      size: file.size,
      type: file.type,
      file,
      uploadedAt: new Date().toLocaleString(),
    }));
    setAttachments(prev => [...prev, ...newAttachments]);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    const files = Array.from(e.dataTransfer.files);
    if (files.length > 0) setPendingFile(files[0]);
    simulateUpload(files);
  };
  // const removeAttachment = (attachId) => {
  //   setAttachments(prev => prev.filter(a => a.id !== attachId));
  // };

  const formatBytes = (bytes) => {
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
    return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
  };

  const getFileIcon = (type) => {
    if (type.startsWith('image/'));
    if (type === 'application/pdf');
    if (type.includes('word'));
    if (type.includes('excel') || type.includes('spreadsheet'));
    if (type.includes('zip') || type.includes('rar'));
    return <FiFile size={24} style={{ color: 'var(--color-text-secondary, #9ca3af)' }} />;
  };

  const fetchMilestonesForProject = async (projectId) => {
    if (!projectId) {
      setMilestones([]);
      return;
    }
    try {
      const data = await projectService.getProjectMilestones(projectId, 'In Progress');
      setMilestones(data.milestones || []);
    } catch (error) {
      console.error('Failed to fetch milestones:', error);
      toast.error(error.response?.data?.error || 'Failed to fetch milestones');
    }
  };
  const handleProjectChange = async (e) => {
    const value = e.target.value;

    console.log("appii",)

    setFormData((prev) => ({
      ...prev,
      project_id: value,
      parent_task_id: '',
    }));

    await fetchMilestonesForProject(value);
    await fetchParentTasksForProject(value);
  };

  if (loading && isEdit) {
    return <div className="loading">Loading task...</div>;
  }

  return (
    <>
      <div className='grid grid-cols-1 xl:grid-cols-[2fr_1fr] gap-6'>
        <div className="row">
          <div className="task-form-header">
            <h1>{isEdit ? 'Edit Task' : 'Create New Task'}</h1>
          </div>

          <div className="tf-tab-bar">
            {TABS.map(tab => (
              <button
                key={tab.id}
                type="button"
                className={`tf-tab ${activeTab === tab.id ? 'tf-tab--active' : ''}`}
                onClick={() => setActiveTab(tab.id)}
              >
                <span className="tf-tab-icon">{tab.icon}</span>
                {tab.label}
              </button>
            ))}
          </div>

          {error && <div className="alert alert-danger">{error}</div>}


          {activeTab === 'details' && (
            <form onSubmit={handleSubmit} className="task-form">

              <div className="">
                <div className="flex flex-col gap-6">

                  {/* Left Container */}
                  <div className="bg-white rounded-xl shadow-md border p-6">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                      <div className="form-group">
                        <label htmlFor="title">Title *</label>
                        <input
                          type="text"
                          id="title"
                          name="title"
                          value={formData.title}
                          onChange={handleChange}
                          className="form-control"
                          required
                          placeholder="Enter task title"
                        />
                      </div>
                      <div className="form-group ">
                        <label htmlFor="project_id">Project*</label>
                        <select
                          id="project_id"
                          name="project_id"
                          value={formData.project_id}
                          onChange={handleProjectChange}
                          className="form-control"
                        >
                          <option value="">Select Project</option>
                          {projects.map(project => (
                            <option key={project.id} value={project.id}>
                              {project.name} ({project.code})
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="form-group">
                        <label htmlFor="milestone_id">Milestone</label>
                        <select
                          id="milestone_id"
                          name="milestone_id"
                          value={formData.milestone_id}
                          onChange={handleChange}
                          className="form-control"
                        >
                          <option value="">Select Milestone (optional)</option>
                          {milestones.map(milestone => (
                            <option key={milestone.id} value={milestone.id}>
                              {milestone.name} {new Date(milestone.due_date).toLocaleDateString()} To {new Date(milestone.completion_date).toLocaleDateString()}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    {/* <div className="mt-5 mb-5">
            <div className="form-group ">
              <label htmlFor="description">Description</label>
              <textarea
                id="description"
                name="description"
                value={formData.description}
                onChange={handleChange}
                className="form-control"
                rows="4"
                placeholder="Enter task description"
              />
            </div>
          </div> */}

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
                      <div className="form-group">
                        <label htmlFor="parent_task_id">Parent Task</label>
                        <select
                          id="parent_task_id"
                          name="parent_task_id"
                          value={formData.parent_task_id}
                          onChange={handleChange}
                          className="form-control"
                        >
                          <option value="">Select Parent Task (optional)</option>
                          {parentTasks
                            .filter(task => !id || task.id !== id)
                            .map(task => (
                              <option key={task.id} value={task.id}>
                                {task.title} {task.project && `(${task.project.code})`}
                              </option>
                            ))}
                        </select>
                      </div>
                      <div className="form-group">
                        <label htmlFor="start_date">Start Date</label>
                        <input
                          type="date"
                          id="start_date"
                          name="start_date"
                          value={formData.start_date}
                          onChange={handleChange}
                          className="form-control"
                        />
                      </div>

                      <div className="form-group">
                        <label htmlFor="due_date">Due Date</label>
                        <input
                          type="date"
                          id="due_date"
                          name="due_date"
                          value={formData.due_date}
                          onChange={handleChange}
                          className="form-control"
                        />
                      </div>

                      <div className="form-group">
                        <label htmlFor="estimated_hours">Estimated Hours</label>
                        <input
                          type="number"
                          id="estimated_hours"
                          name="estimated_hours"
                          value={formData.estimated_hours}
                          onChange={handleChange}
                          className="form-control"
                          min="0"
                          step="0.5"
                          placeholder="0.0"
                        />
                      </div>

                      <div className="form-group">
                        <label htmlFor="actual_hours">Completed Hours</label>
                        <input
                          type="number"
                          id="actual_hours"
                          name="actual_hours"
                          value={formData.actual_hours}
                          onChange={handleChange}
                          className="form-control"
                          min="0"
                          step="0.5"
                          placeholder="0.0"
                        />
                      </div>

                      <div className="form-group">
                        <label htmlFor="remaining_hours">Remaining Hours</label>
                        <input
                          type="number"
                          id="remaining_hours"
                          name="remaining_hours"
                          value={formData.remaing_hours || 0}
                          onChange={handleChange}
                          className="form-control"
                          min="0"
                          step="0.5"
                          placeholder="0.0"
                        />
                      </div>

                    </div>
                    <div>
                      <RichTextEditor
                        value={formData.description}
                        label='Description'
                        onChange={(value) =>
                          setFormData(prev => ({ ...prev, description: value }))
                        }
                        height="150px"
                      />
                    </div>
                  </div>

                  {/* <div className="form-row">
          <div className="form-group col-md-12">
            <label htmlFor="assignee_id">Assignee ID</label>
            <input
              type="text"
              id="assignee_id"
              name="assignee_id"
              value={formData.assignee_id}
              onChange={handleChange}
              className="form-control"
              placeholder="Enter assignee ID (optional)"
        />
      </div>
        </div> */}

                </div>



              </div>


            </form>
          )}
          {activeTab === 'attachments' && (
            <div className="tf-tab-panel tf-attachments-panel ">
              <div
                className={`tf-dropzone ${dragOver ? 'tf-dropzone--active' : ''}`}
                onDragOver={(e) => { e.preventDefault(); setDragOver(true); }}
                onDragLeave={() => setDragOver(false)}
                onDrop={handleDrop}
                style={{ maxWidth: '900px', margin: '0 auto', maxHeight: '300px', overflowY: 'auto' }}
              >
                <input
                  type="file"
                  multiple
                  onChange={handleFileChange}
                  style={{ display: 'none' }}
                  id="file-upload"
                />
                <label htmlFor="file-upload" style={{ cursor: 'pointer', display: 'block', textAlign: 'center', padding: '2rem 1rem' }}>
                  {pendingFile ? (
                    <>
                      <FiFile size={48} style={{ color: 'var(--color-primary, #2563eb)', marginBottom: '0.5rem' }} />
                      <p style={{ margin: '0 0 0.25rem', fontWeight: 600, fontSize: '0.95rem' }}>
                        {pendingFile.name}
                      </p>
                      <p style={{ margin: 0, fontSize: '0.85rem', color: 'var(--color-text-secondary)' }}>
                        {formatBytes(pendingFile.size)}
                      </p>
                    </>
                  ) : (
                    <>
                      <FiUpload size={48} style={{ color: 'var(--color-text-secondary, #9ca3af)', marginBottom: '0.5rem', marginLeft: '4.5rem' }} />
                      <p style={{ margin: '0 0 0.25rem', fontWeight: 500 }}>
                        Click to upload or drag and drop
                      </p>
                      <p style={{ margin: 0, fontSize: '0.85rem', color: 'var(--color-text-secondary)' }}>
                        Maximum file size: 50 MB
                      </p>
                    </>
                  )}
                </label>
              </div>

              {/* Upload Progress */}
              {uploadProgress > 0 && uploadProgress < 100 && (
                <div style={{ marginTop: '1rem' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.85rem', color: 'var(--color-text-secondary)', marginBottom: '0.25rem' }}>
                    <span>Uploading...</span>
                    <span>{uploadProgress}%</span>
                  </div>
                  <div style={{ width: '100%', background: 'var(--color-border, #e5e7eb)', borderRadius: '9999px', height: '8px' }}>
                    <div
                      style={{
                        width: `${uploadProgress}%`,
                        height: '8px',
                        borderRadius: '9999px',
                        background: 'var(--color-primary, #2563eb)',
                        transition: 'width 0.3s ease',
                      }}
                    />
                  </div>
                </div>
              )}

              {/* Attachment list */}
              {/* {attachments.length > 0 ? (
            <>
              <ul className="tf-attachment-list">
                {attachments.map((attachment) => (
                  <li key={attachment.id} className="tf-attachment-item">
                    <span className="tf-attachment-file-icon">
                      {getFileIcon(attachment.type)}
                    </span>
                    <div className="tf-attachment-info">
                      <span className="tf-attachment-name">{attachment.name}</span>
                      <span className="tf-attachment-meta">
                        {formatBytes(attachment.size)} · {attachment.uploadedAt}
                      </span>
                    </div>
                    <button
                      type="button"
                      className="tf-attachment-remove"
                      onClick={() => removeAttachment(attachment.id)}
                      aria-label={`Remove ${attachment.name}`}
                    >
                      <FiX size={14} />
                    </button>
                  </li>

                ))}
              </ul>

              <div className="d-flex justify-content-end mt-4">
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={loading}
                >
                  Save
                </button>
              </div>
            </>
          ) : (
            <p className="tf-empty-msg">No attachments yet.</p>
          )} */}


              {attachment ? (
                <>
                  <ul className="tf-attachment-list">
                    <li className="tf-attachment-item">
                      <span className="tf-attachment-file-icon">
                        {getFileIcon(attachment.type)}
                      </span>

                      <div className="tf-attachment-info">
                        <span className="tf-attachment-name">
                          {attachment.name}
                        </span>

                        <span className="tf-attachment-meta">
                          {formatBytes(attachment.size)} · {attachment.uploadedAt}
                        </span>
                      </div>

                      <button
                        type="button"
                        className="tf-attachment-remove"
                        onClick={removeAttachment}
                        aria-label={`Remove ${attachment.name}`}
                      >
                        <FiX size={14} />
                      </button>
                    </li>
                  </ul>

                  <div className="d-flex justify-content-end mt-4">
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={loading}
                      onClick={handleLogoUpload}
                    >
                      Save
                    </button>
                  </div>
                </>
              ) : (
                <p className="tf-empty-msg">No attachment yet.</p>
              )}



            </div>
          )}

          {activeTab === 'history' && (
            <div className="tf-tab-panel tf-history-panel ">
              <div className="tf-empty-state">
                {/* <p className="tf-empty-state-title bold text-center">No history found</p> */}

                <div className="comments-section no-shadow text-center">
                  <h3>Comments ({comments.length})</h3>

                  <form onSubmit={handleAddComment} className="comment-form " style={{ maxWidth: '900px', margin: '0 auto' }}>
                    <textarea
                      value={newComment}
                      onChange={(e) => setNewComment(e.target.value)}
                      placeholder="Add a comment..."
                      className="form-control"
                      rows="3"
                    />
                    <button type="submit" className="btn btn-primary">
                      Add Comment
                    </button>
                  </form>

                  <div className="comments-list">
                    {comments.map((comment) => (
                      <div className="timeline-item" key={comment.id}>


                        <div className="timeline-dot"></div>

                        {/* Comment Card */}
                        <div className="comment">
                          <div className="timeline-avatar">
                            {comment.user?.avatar_url ? (
                              <img
                                src={comment.user.avatar_url}
                                alt=""
                                className="avatar"
                              />
                            ) : (
                              <div className="avatar-placeholder">
                                {comment.user?.first_name?.charAt(0)}
                              </div>
                            )}

                            <span className="author-name">
                              {comment.user?.first_name} {comment.user?.last_name}
                            </span>
                          </div>
                          <div className="comment-body">
                            <span className="comment-date">
                              {new Date(comment.createdAt).toLocaleString()}
                            </span>
                          </div>

                          <div className="comment-body">
                            {comment.comment}
                          </div>
                        </div>

                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        {activeTab !== 'attachments' && activeTab !== 'history' && (
          <form onSubmit={handleSubmit} className="task-form" style={{ marginTop: '65px' }}>
            <div className="row">
              <div className="col-md-12">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4" >
                  <div className="form-group">
                    <label htmlFor="task_type">Task Type *</label>
                    <select
                      id="task_type"
                      name="task_type"
                      value={formData.task_type}
                      onChange={handleChange}
                      className="form-control"
                      required
                    >
                      <option value="Task">Task</option>
                      <option value="Bug">Bug</option>
                      <option value="Feature">Feature</option>
                      <option value="Epic">Epic</option>
                      <option value="Story">Story</option>
                    </select>
                  </div>

                  <div className="form-group">
                    <label htmlFor="status">Status *</label>
                    <select
                      id="status"
                      name="status"
                      value={formData.status}
                      onChange={handleChange}
                      className="form-control"
                      required
                    >
                      <option value="To Do">To Do</option>
                      <option value="In Progress">In Progress</option>
                      <option value="In Review">In Review</option>
                      <option value="Done">Done</option>
                      <option value="Blocked">Blocked</option>
                    </select>
                  </div>

                  <div className="form-group">
                    <label htmlFor="priority">Priority *</label>
                    <select
                      id="priority"
                      name="priority"
                      value={formData.priority}
                      onChange={handleChange}
                      className="form-control"
                      required
                    >
                      <option value="Low">Low</option>
                      <option value="Medium">Medium</option>
                      <option value="High">High</option>
                      <option value="Critical">Critical</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label htmlFor="assigned_to">Assignee ID</label>
                    <select
                      id="assigned_to"
                      name="assigned_to"
                      value={formData.assigned_to}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="Select assignee"
                    >
                      <option value="">Unassigned</option>
                      {users.map(user => (
                        <option key={user.id} value={user.id}>
                          {user.first_name} {user.last_name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div >
                  <div className="form-group" style={{ marginBottom: "100px" }}>
                    <label htmlFor="tags">Tags</label>
                    <input
                      type="text"
                      id="tags"
                      name="tags"
                      value={formData.tags}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="Enter tags (comma-separated)"
                    />
                  </div>
                </div>
                <div>
                  {/* Buttons */}
                  <div className="flex justify-end gap-3 mt-6" style={{ marginTop: "240px" }}>
                    <button
                      type="button"
                      onClick={handleCancel}
                      className="btn btn-secondary"
                    >
                      Cancel
                    </button>

                    <button
                      type="submit"
                      className="btn btn-primary"
                    >
                      {loading ? "Saving..." : isEdit ? "Update Task" : "Create Task"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>

        )}
      </div>
    </>
  );
};

export default TaskForm;

